import { render, staticRenderFns } from "./TxHistoryMobile.vue?vue&type=template&id=674e616e"
import script from "./TxHistoryMobile.vue?vue&type=script&lang=js"
export * from "./TxHistoryMobile.vue?vue&type=script&lang=js"
import style0 from "./TxHistoryMobile.vue?vue&type=style&index=0&id=674e616e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports